import React from 'react';



const Instruction = () => {
    return (
        <>

<div className="breadcrumbs overlay">
    <div className="container">
      <div className="bread-inner">
        <div className="row">
          <div className="col-12">
            <h2>Instruction</h2>
          </div>
        </div>
      </div>
    </div>
  </div>
            <section>
           <div>
           <img src='https://wallabieswarmcares.com/images/instruction.jpg'/>
           </div>
            </section>
        </>
    );
};

export default Instruction;
